// Where to get the traffic data
export const SOURCE_URL = "https://developer.fastly.com/api/internal/stream/sse?channels=traffic-log"

// Mapping of input data's service name field
export const SERVICES = {
  JSD: "jsDelivr",
  MSTDN: "Mastodon",
}

// CSS colors for each service name.  If no custom color is defined for a service, white will be used.
export const SERVICE_COLORS = {
  JSD: "rgba(255,149,9,0.6)",
  MSTDN: "rgba(94,84,235,0.7)",
}

export const HIGHLIGHT_COLOR = "#ff0000"
export const HIGHLIGHT_MAX_START_FROM_POV = 2500
export const HIGHLIGHT_MIN_ARC_DIST = 200

export const HIGHLIGHT_CONTENT = (req) => {
  const svcName = SERVICES[req.service] || "Unknown service"
  const browser = BROWSERS[req.browser] || "Other"
  const cache = req.cache === "H" ? "HIT" : "MISS"
  return (
    `<strong>${req.pop.name}</strong> serving ${svcName}` +
    `<ul>` +
    `<li>HTTP/${req.httpVer}</li>` +
    `<li>TLS ${req.tlsVer}</li>` +
    `<li>${browser}</li>` +
    `<li>${cache}</li>` +
    `<li>${req.elapsedMS}ms</li>` +
    `<li>${req.dist}km</li>` +
    `</ul>`
  )
}

// How many requests to hold in the history
export const MAX_HISTORY = 250

// How long it takes for an arc to fly from origin to destination on the map, in milliseconds.
export const ARC_FLIGHT_TIME = 1000

// How long the arc should remain in place before it animates away, in units of the arc's length.  For example, a value of 3 means the arc should hold in place for 3 times longer than it takes to draw it initially.
export const ARC_HOLD = 4

// The shortest and longest arcs to display, in real world kilometers.  Many requests travel very short distances, so displaying these requests may make the visualization uninteresting.  For those that travel more than about 6000km it's not possible to see both the start and end point of the arc at the same time - plus such requests are often anomalous and generally worth filtering out.
export const MIN_ARC_DIST = 70
export const MAX_ARC_DIST = 2000

export const MAX_START_FROM_POV = 12000

// How often to remove arcs that have completed animating, in milliseconds
export const CLEANUP_INTERVAL = ARC_FLIGHT_TIME / 2

// How often the globe should automatically reposition itself on a preset point of view, in milliseconds
export const SPIN_INTERVAL = 10000

// Mapping of input data's browser field to full browser names
export const BROWSERS = {
  C: "Chrome",
  S: "Safari",
  F: "Firefox",
  E: "Microsoft Edge",
  K: "Kindle Browser",
  A: "Samsung Browser",
}

// Mapping of input data's connection type field
export const CONN_TYPES = {
  W: "Wifi",
  C: "Wired",
  S: "Satellite",
  M: "Mobile",
  D: "Dial-up",
}

// Preset point of view positions to cycle through
export const POVS = [
  { lat: 35, lng: -98.5, altitude: 1.6 }, // N America
  { lat: -20, lng: -65, altitude: 1.6 }, // S America
  { lat: 50, lng: 0, altitude: 1.6 }, // Europe
  { lat: 25, lng: 100, altitude: 1.6 }, // Asia
  { lat: -35, lng: 150, altitude: 1.6 }, // Aus/NZ
]
